/**
 * useDocumentTitle Hook
 * Sets the browser document title for better history/tab identification
 * Issue #896: Page names in browser history
 */

import { useEffect } from 'react';

const BASE_TITLE = 'ORO move';

/**
 * Set document title with consistent suffix
 * @param title - Page-specific title (e.g., "Stoll Family Fitness", "Morning Run")
 * @param options - Optional config
 */
export function useDocumentTitle(
  title: string | undefined | null,
  options: { suffix?: boolean } = { suffix: true }
) {
  useEffect(() => {
    const previousTitle = document.title;

    if (title) {
      document.title = options.suffix ? `${title} | ${BASE_TITLE}` : title;
    } else {
      document.title = BASE_TITLE;
    }

    // Restore previous title on unmount (optional, for SPA navigation)
    return () => {
      document.title = previousTitle;
    };
  }, [title, options.suffix]);
}

export default useDocumentTitle;
